export const DISPLAY_ID_PREFIXES = [
  'AER-S',
  'AER-R',
  'AM-',
  'D-0',
  'DNK-',
  String.raw`ENV\d`,
  'EVHK',
  'EVO-',
  'GES-',
  'PRA-',
  'T-',
  'W-0',
  'BCN-',
  'AEC-',
  'LIS-',
  'MAD-',
  'VLC-',
  'MIL-',
  'OI-',
  String.raw`CL\d`, // the prefix starts with CL and the next char is a number
  String.raw`RL\d`,
  'G-0',
  'EAVCHCOM',
  'EVADEV-',
  // CZ prefixes
  'EVP-',
  'EVL-',
  'EVB-',
] as const;
